import Litepicker from 'litepicker';

export default (name = 'litepicker') => ({
  date: null,
  open: false,
  litepicker: null,
  dateFrom: '',
  dateTo: '',

  openToggle() {
    if (this.open) {
      this.litepicker.hide();
    } else {
      this.open = true;
    }
  },

  dateFormat(date) {
    // Zero-pad the month and day
    const pad = (num) => num.toString().padStart(2, '0');

    // Format the date components
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate())
    );
  },

  init() {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    const ietfLanguage = document.documentElement.getAttribute('data-lang');
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };

    this.litepicker = new Litepicker({
      element: document.getElementById(name),
      singleMode: false,
      minDate: date,
      numberOfMonths: 2,
      numberOfColumns: 2,
      showTooltip: false,
      setup: (picker) => {
        picker.on('selected', () => {
          this.open = false;
          let date = picker.getDate();
          if (date) {
            this.date =
              picker.getStartDate().toLocaleString(ietfLanguage, options) +
              ' - ' +
              picker.getEndDate().toLocaleString(ietfLanguage, options);
            this.dateFrom = this.dateFormat(picker.getStartDate());
            this.dateTo = this.dateFormat(picker.getEndDate());
            const event = new CustomEvent('date-pick:set', {
              detail: {
                startDate: picker.getStartDate(),
                endDate: picker.getEndDate(),
              },
            });

            // Dispatch the event on the desired element, e.g., document
            window.dispatchEvent(event);
          }
        });
        picker.on('hide', () => {
          this.open = false;
        });
      },
    });
  },
});
